import { IApplicationState } from '../../types/redux';
import { getRegionId } from '../getRegionId';
import { getRegionParentId } from '../getRegionParentId';

export function isAvailableInRegions(availableRegions: number[]) {
  return (state: IApplicationState) => {
    const regionId = getRegionId(state);
    const regionParentId = getRegionParentId(state);

    return availableRegions.includes(regionId) || !!regionParentId && availableRegions.includes(regionParentId);
  };
}
